export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3/node_modules/d3-path/index.js
// module id = 701
// module chunks = 0